import React from 'react';
import { Typography } from 'antd';
import { SelectCompany } from '../../controllers/SelectCompany';
import { useCompaniesQuery } from '../../../../api/companies';
import ToCreateAcceptance from '../../controllers/ToCreateAcceptance';
import { useUserAcceptanceRole } from '../../../../shared/hooks/userAcceptanceRole';
import styles from './index.module.scss';

const Header = () => {
  const { data: companies } = useCompaniesQuery();

  const role = useUserAcceptanceRole();

  const selectCompanyDisabled = companies.length === 0;

  return (
    <header className={styles.root}>
      <div className={styles.col}>
        <div>
          <SelectCompany disabled={selectCompanyDisabled} />
          {selectCompanyDisabled && (
            <Typography.Text type="danger">
              Нет доступных компаний
            </Typography.Text>
          )}
        </div>
      </div>
      {role.isDirector && <ToCreateAcceptance />}
    </header>
  );
};

export default Header;
